import { render } from "./header_info.vue?vue&type=template&id=46d6b872"
import script from "./header_info.vue?vue&type=script&lang=js"
export * from "./header_info.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__